module.exports = __webpack_public_path__ + "img/xiaofeng.9f1f6e85.png";